import { useContext } from 'react';
import { useSnapshot } from 'valtio';

import { FlowCoreContext } from './FlowCoreContext';

export const useFlow = () => {
  const flowContext = useContext(FlowCoreContext);
  const flowSnapshot = useSnapshot(flowContext);

  return flowSnapshot.value;
};
